export const capitalize = (str: string) => {
	let newStr = str.toLowerCase().trim();
	if (!newStr.length) return newStr;

	newStr = newStr.charAt(0).toUpperCase() + newStr.slice(1);
	return newStr;
};

export const normalize = (str: string) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const emptyToNull = (v?: string | null) => (v?.trim() ? v.trim() : null);
